'use client';

import { TruncatingWrapper } from '@/components/Shared/TruncatingWrapper';
import { useFindTable } from '@/hooks/swr/useDataset';
import { useRouteParams } from '@/hooks/useRouteParams';
import { Dataset } from '@/lib/types/Dataset';
import { DatasetSidebarItem } from './Item';
import { DatasetSidebarSkeleton } from './Skeleton';
import classes from './classes';
interface DatasetSidebarProps {
  dataset: Dataset;
}
export function DatasetSidebar({
  dataset
}: DatasetSidebarProps) {
  const {
    tableAction,
    tableName
  } = useRouteParams();
  const {
    table
  } = useFindTable(dataset, tableName);
  if (!dataset || !table) {
    return <DatasetSidebarSkeleton />;
  }
  return <div className="px-4 md:p-0 flex flex-col w-full md:w-4/12 gap-5 md:gap-10 shrink-0">
      <div className="space-y-2">
        <h5 className={classes.heading}>Source</h5>
        <p className={classes.paragraph}>{dataset.source.display_name.en}</p>
      </div>
      <div className="space-y-2">
        <h5 className={classes.heading}>Description</h5>
        <TruncatingWrapper height="sm" text={dataset.description.plaintext.en} maxLength={255}>
          <p className={classes.paragraph}>
            {dataset.description.plaintext.en}
          </p>
        </TruncatingWrapper>
      </div>
      <div className="space-y-2">
        <h5 className={classes.heading}>Keywords</h5>
        <p className={classes.paragraph}>
          {dataset.tags.map(t => t.display_name.en).join(', ')}
          {dataset.tags.length === 0 && 'No keywords'}
        </p>
      </div>

      <div className="flex flex-col gap-5">
        <h5 className={classes.heading}>Tables</h5>
        <div className="flex flex-col gap-3">
          {dataset.tables.map(table => <DatasetSidebarItem key={`dataset-sidebar-item-${table.id}`} dataset={dataset} table={table} tableAction={tableAction} />)}
        </div>
      </div>
    </div>;
}